import image1 from '../../image-source/Booking/Booking-01.png'
import image2 from '../../image-source/Booking/Booking-02.png'
import image3 from '../../image-source/Booking/Booking-03.png'
const hotelInfo = [
    {
        description : "Light brighr airy stylish apt & safe peaceful stay",
        facality : "4 guests  2 bedrooms  2 beds  2 baths",
        compatablity : "Cancellation fexibility available",
        price : "34",
        image : image1
    } ,

    {
        description : "Apartment in Lost Panorama",
        facality : "4 guests  2 bedrooms  2 beds  2 baths",
        compatablity : "Cancellation fexibility available",
        price : "52",
        image : image2
    } ,

    {
        description : "AR Lounge & Pool ( r&r + b&b )",
        facality : "4 guests  2 bedrooms  2 beds  2 baths",
        compatablity : "Cancellation fexibility available",
        price : "44",
        image : image3

    } ,
]

export default hotelInfo